import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { Windows } from 'landings/windows';
import { RemoteProps } from './widgets-types';

export const WindowsRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <Windows />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
